export default __webpack_public_path__ + "static/media/edit.354ee30f.svg";